import { gql } from '@apollo/client'

const GET_USER_STORES = gql`
  query GetUserStores($userId: uuid!) {
    store_users(where: { user_id: { _eq: $userId } }) {
      store_id
      store {
        name
      }
    }
  }
`

export { GET_USER_STORES }
